module.exports = __webpack_public_path__ + "img/4-TWK-Live-Chat-Page-MVP.7962bf94.png";